import React from 'react';

import _ from 'underscore';

import * as SchemaFieldConstants from 'schemas/fields/SchemaFieldConstants';
import {displayPath} from 'registry/field/FieldPathUtil';
import Tooltip from 'ui-library/bs/Tooltip';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';

function _tagSchemaGraphToOrderedPath(tagSchemaGraph) {
  // Assume `edges` are ordered and a forward path. Divide them into `orderedPath` (everything but the last
  // field) and `hoistedField` (the last field).
  //
  // TODO(T10276): Refactor into a method shared between `HoistedTagNameBadge` and hoisted fields table.
  // eslint-disable-next-line no-restricted-syntax
  return _.initial(tagSchemaGraph.edges);
}

export default function HoistedTagNameBadge(props) {
  const orderedPath = _tagSchemaGraphToOrderedPath(props.tagSchemaGraph);
  return (
    <span className="u-no-wrap">
      <Tooltip
        title={displayPath({sourceTagSchemaId: orderedPath[0].from.id, tagSchemaFieldEdges: orderedPath})}
      >
        <span>
          <Button
            buttonStyle={ButtonStyle.TERTIARY_BLUE}
            className="u-no-mouse-target"
            size={ButtonSize.MINI}
            text="Hoisted"
          />
        </span>
      </Tooltip>
    </span>
  );
}

HoistedTagNameBadge.propTypes = {
  tagSchemaGraph: SchemaFieldConstants.TAG_SCHEMA_GRAPH.isRequired,
};
